// import Vue from 'vue'
import router from './routerMap.js'
import store from '../store'
const setTitle = (route) => {
  document.title = route.meta.title ? route.meta.title : ''
}

router.beforeEach((to, from, next) => {
  store.commit('changeBgColor', to.meta.bgcolor)
  next()
})

router.afterEach(route => {
  setTitle(route)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js